import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[NumericOnlyInput]'
})
export class NumericOnlyInputDirective {
   @Input() decimalPlaces: number = 0;
   private regex: RegExp = new RegExp(/^-?\d*\.?\d{0,2}$/g);
   private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Meta', 'Control'];

   constructor(private el: ElementRef) { }

   @HostListener('keydown', ['$event'])
   onKeyDown(event: KeyboardEvent) {
      if ((event.ctrlKey || event.metaKey) &&
        (event.key === 'a' || event.key === 'c' || event.key === 'v' || event.key === 'x')) {
         return;
      }

      if (this.specialKeys.indexOf(event.key) !== -1) {
         return;
      }

      if (this.decimalPlaces !== 0) {
         this.setNewRegex();
      } else {
         this.regex = new RegExp(/^-?\d*$/g);
      }

      let current: string = this.el.nativeElement.value;
      let input = this.el.nativeElement;

      const startPos = input.selectionStart;
      const endPos = input.selectionEnd;

      let next: string = current.substring(0, startPos) + event.key + current.substring(endPos);
      if (next && !String(next).match(this.regex)) {
         event.preventDefault();
      }
   }

   private setNewRegex() {
      this.regex = new RegExp(`^-?\\d*\\.?\\d{0,${this.decimalPlaces}}$`);
   }
}
